<template>
  <div class="contacts-map" ref="map" />
</template>
<script>
  export default {
    props: {
      center: Array,
      zoom: {
        type: String,
        default: "15",
      },
      title: String,
      content: String,
      coords: Array,
      img: {
        type: String,
        default: '/local/images/icons/map_marker.png',
      },
      size: {
        type: Array,
        default: () => ["45", "58"]
      },
      offset: {
        type: Array,
        default: () => ["-20", "-50"]
      },
      controls: {
        type: Array,
        default: () => ['zoomControl'],
      }
    },
    computed: {
      mapConfig() {
        return {
          center: this.center || this.coords,
          zoom: this.zoom,
          controls: this.controls
        }
      },
      placemarkData() {
        return {
          hintContent: this.title,
          balloonContent: this.content
        }
      },
      placemarkOptions() {
        return {
          iconLayout: 'default#image',
          iconImageHref: this.img,
          iconImageSize: this.size,
          iconImageOffset: this.offset,
        }
      }
    },
    mounted() {
      ymaps.ready(() => {
        this.map = new ymaps.Map(this.$refs['map'], this.mapConfig);
        this.map.geoObjects.add(new ymaps.Placemark(this.coords, this.placemarkData, this.placemarkOptions));
      });
    },
    beforeDestroy() {
      this.map.destroy();
    }
  }
</script>
<style scoped>
  .contacts-map {
    width:100%;
    height:460px;
  }
</style>
